var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"page-container"},[_vm._v("403 No permissions")])
}
var staticRenderFns = []

export { render, staticRenderFns }